import React, { Component } from 'react';


import {Modal, Button, Grid, Row, Col} from 'react-bootstrap';
import ReactDOM from 'react-dom';

class fairsAndDates extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.state = {
      show: false,
      fair: 'Default',
      listItemsProperties: ''
    };





  }

  handleClose() {
    this.setState({ show: false });
  }
  handleShow() {
    this.setState({ show: true });
  }



  handleUpdate(exhib) {
    var exhibTmp = JSON.parse(exhib);
    var exhibArr = exhibTmp[0].Exhibitor;
    this.setState({listItemsProperties: exhibArr.map((elementEx) =>
    <li key={elementEx.NameEx}>{elementEx.NameEx} &nbsp;-&nbsp; {elementEx.Booth} </li>
    )});
    return (
      <ul>{this.state.listItemsProperties}</ul>
    );
  }

  getCurrentDate(){
    var today = new Date(),
            returnVal =  today.getFullYear() + '' + ((today.getMonth() + 1)<10? '0' + (today.getMonth() + 1):(today.getMonth() + 1)) + '' + ((today.getDate())<10? '0' + (today.getDate()):(today.getDate()));
    return returnVal;
    }

  render() {

      var data;
      var builtTmp;
      var parseString = require('xml2js').parseString;
        fetch('/fairData.xml')
        .then((r) => r.text())
        .then(text  => {
          parseString(text, function (err, result) {
              data=result;
              const todayDate = Number(this.getCurrentDate());
              var tmpOV = JSON.parse(JSON.stringify(result));
              data= tmpOV.Fairs.Fair;
              builtTmp = data.map((element) => {
                return Number(element.Year + '' + element.MonthEnd + '' + element.DayEnd)>todayDate?
                 <div className={element.CSS}>
                   <div className="fairDivMainCont">
                        <div className="fairDivInfoCont">
                           <Grid className="newsGridLeft">
                             <Row className="show-grid">
                               <Col sm={2} xsHidden >
                                 <h2>
                                   {element.Name}
                                 </h2>
                                 <h3>
                                   {element.Location}
                                 </h3>
                                 <h3>{element.DM}</h3>
                                 <h4>{element.Year}</h4>
                                 &nbsp;
                                 </Col>
                                 <Col sm={10} xsHidden >
                                  <img src={`../fairs/${element.Image}`} alt=""></img>
                                   <p className="fairDesc">
                                    {element.Desc}
                                     </p>
                                     <Button bsStyle="link" onClick={() => {
                                       this.setState({fair: element.Name});
                                       this.handleUpdate(JSON.stringify(element.Exhibitors));
                                       this.handleShow();
                                     }}>Unsere Hersteller vor Ort</Button>
                                   </Col>
                               <Col xs={12} smHidden mdHidden lgHidden>
                                <img src={`../fairs/${element.Image}`} alt=""></img>
                                 <h2>{element.Name}</h2>
                                 <h3>
                                   {element.Location}
                                 </h3>
                                 <h3>
                                   {element.DM}
                                 </h3>
                                 <h4>{element.Year}</h4>
                                 &nbsp;
                                 <p className="fairDesc">
                                  {element.Desc}
                                   </p>
                                   <Button bsStyle="link" onClick={() => {
                                     this.setState({fair: element.Name});
                                     this.handleUpdate(JSON.stringify(element.Exhibitors));
                                     this.handleShow();
                                   }}>Unsere Hersteller vor Ort</Button>
                                 </Col>
                             </Row>
                           </Grid>
                        </div>
                      <div className={"fairDivOverlayCont" + ' ' + element.$.status}>
                        <h1>Dieser Termin fällt leider aus!</h1>
                        <h2>Für weitere Informationen kontaktieren Sie uns gerne telefonisch.</h2>
                      </div>
                      </div>
                    <div>
                    </div>
                   </div>
                : <div></div>});

            }.bind(this));
            this.builtElement = ReactDOM.render(builtTmp, document.getElementById('fairsRoot'));
            console.log(this.builtElement);
        });
    return (
        <div className='container-fluid newsMain'>
          <center><h1 className="titleNews">Messen und Termine</h1></center>
          <div className='container-fluid disabledVA' id="fairsRoot"></div>
        <Modal show={this.state.show} onHide={this.handleClose} >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.fair}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul className='unordEnumBase'>{this.state.listItemsProperties}</ul>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Schließen</Button>
          </Modal.Footer>
        </Modal>
      </div>

    );
  }
}

export default fairsAndDates;



// WEBPACK FOOTER //
// ./src/components/pages/fairsAndDates.js